export default {
  name: "VerificationResponse",
  path: "response",
  component: () => import("@/views/Verification/Response")
};
